/*
 * @Author: Tina Huang
 * @Date: 2024-05-13 12:13:49
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:12:05
 * @Description:
 */

import axios from 'axios'
// import { NOTION_TOKEN } from './config'
import { AxiosRequestConfig } from 'axios'
// import { message } from 'antd'

/**
 * 网络请求响应格式，T 是具体的接口返回类型数据
 */
interface CustomSuccessData<T> {
  code?: number
  msg?: string
  message?: string
  data: T
  [keys: string]: any
}

const instance = axios.create({
  timeout: 10000,
  baseURL: 'http://localhost:3030',
})

instance.defaults.headers.post['Content-Type'] = 'application/json'

/** 添加请求拦截器 **/
instance.interceptors.request.use(
  (config) => {
    // config.headers['token'] = NOTION_TOKEN //在请求头中加入token
    // 如果还需要在请求头内添加其他内容可以自己添加 "[]" 内为自定义的字段名 "=" 后的内容为字段名对应的内容
    // config.headers['自定义键'] = '自定义内容'
    // 如果此时觉得某些参数不合理，你可以删除它，删除后将不会发送给服务器
    // delete config.data.userName
    // userName是你传递的参数名，或许你可以试着在控制台输出config看看它包含了什么

    // 对应可以删除也可以在此添加一些参数
    // config.data.userName = '天道酬勤'
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  (res: { data: any; status: number }) => {
    if (res.data?.status && res.data.status !== 200) return Promise.reject(res)
    return Promise.resolve(res.data)
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

/**
 * @description: 封装post请求方法
 * @param {string} url url 请求地址
 * @param {string | object} data 请求参数
 * @param {AxiosRequestConfig} config 请求配置
 * @return {Promise<CustomSuccessData<T>>} 返回的接口数据
 */
const post = <T>(url: string, data?: string | object, config?: AxiosRequestConfig): Promise<CustomSuccessData<T>> => {
  config = {
    method: 'post',
    url,
    ...config,
  }
  if (data) {
    config.data = data
  }
  console.log(config)
  return instance(config)
}
const get = <T>(url: string, data?: string | object, config?: AxiosRequestConfig): Promise<CustomSuccessData<T>> => {
  config = {
    method: 'get',
    url,
    ...config,
  }
  if (data) {
    config.data = data
  }
  return instance(config)
}

const http = {
  post,
  get,
}

export default http
